const SET_SIGN_OUT_IS_VISIBLE = 'SET_SIGN_OUT_IS_VISIBLE';

export { SET_SIGN_OUT_IS_VISIBLE };



// WEBPACK FOOTER //
// ./src/containers/Inputs/SignOut/constants.js